import React from 'react';
import { ActionButtonText, QuestionState } from '../../../../constans/question-enums';
import ActionButtons from './action-buttons/action-buttons';
import { TUpdateQuestion } from '../../../../store/question-store/question-store';
import { getGMTDate } from '../../../../utils/helpers/date-helper';
import { observer } from 'mobx-react';
import { getMixpanelService } from '../../../../utils/services/mixpanel-service-instance';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../../../constans/mixpanel-contants';

interface IButtonProperties {
  buttonText: ActionButtonText;
  cls: string;
  state: QuestionState;
}

export interface IActionButtonProps {
  isDisabled: boolean;
  updateHandler: (stateType: QuestionState) => void;
  buttonProperties: IButtonProperties[];
}

interface IProps {
  stateType: string;
  isDisabled: boolean;
  updateMessage: TUpdateQuestion;
  messageId: string | null;
  setActiveMessageId: (messageId: string | null) => void;
  isReviewMode?: boolean;
}

const QuestionActionButtons: React.FC<IProps> = ({ stateType, isDisabled, updateMessage, messageId, setActiveMessageId, isReviewMode }): JSX.Element | null => {
  const updateQuestionHandler = (questionStateType: QuestionState): void => {
    updateMessage(messageId, questionStateType, getGMTDate());
    setActiveMessageId(messageId);

    if(questionStateType === QuestionState.REVIEW) {
      getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.QATab, MIXPANEL_EVENT_TYPES.MOVE_TO_UNANSWERED);
    }
  };

  const answeredAndRemovedButtonProperties: IButtonProperties[] = [
    {
      buttonText: ActionButtonText.MARK_ANSWERED,
      cls: 'ok-icon theme-blue',
      state: QuestionState.ANSWERED,
    },
    {
      buttonText: ActionButtonText.MARK_REMOVED,
      cls: 'remove-icon theme-red',
      state: QuestionState.REMOVED,
    },
  ];

  const reviewButtonProperties: IButtonProperties[] = [
    {
      buttonText: isReviewMode ? ActionButtonText.MOVE_REVIEW : ActionButtonText.MOVE_UNANSWERED,
      cls: 'return-icon theme-blue',
      state: QuestionState.REVIEW,
    },
  ];

  switch (stateType) {
    case QuestionState.REVIEW:
    case QuestionState.PRIORITIZED:
    case QuestionState.PRESENTER:
      return (
        <ActionButtons
          isDisabled={isDisabled}
          updateHandler={updateQuestionHandler}
          buttonProperties={answeredAndRemovedButtonProperties}
        />);

    case QuestionState.REMOVED:
    case QuestionState.ANSWERED:
      return (
        <ActionButtons
          isDisabled={isDisabled}
          updateHandler={updateQuestionHandler}
          buttonProperties={reviewButtonProperties}
        />);

    default:
      return null;
  }
};

export default observer(QuestionActionButtons);

